import { RealtimeRole } from '@doxyme/realtime';
import { PEOPLE_TYPES } from '../../store/features/realtime/presence';
export const getPersonTypeFromIdentity = ({ role, }) => {
    if (role === RealtimeRole.Provider) {
        return PEOPLE_TYPES.doctor;
    }
    if (role === RealtimeRole.Patient) {
        return PEOPLE_TYPES.patient;
    }
};
